import SessionModel from "../api/models/SessionModel";

export const sessionPagination = (
  targetSessionIndex: number,
  sessions: SessionModel[]
) => {
  if (!isValidSession(sessions[targetSessionIndex])) {
    return null;
  }
  let targetSession = sessions[targetSessionIndex];
  let disabledNext = !isValidSession(sessions[targetSessionIndex + 1]);
  let disabledPrev = !isValidSession(sessions[targetSessionIndex - 1]);
  return {
    sessionData: targetSession,
    disabledPrev,
    disabledNext,
  };
};

const isValidSession = (session?: SessionModel) => {
  return !!session && (session.isDone || session.isInProgress);
};
